import { render } from "./TablesList.vue?vue&type=template&id=ccc5be66&scoped=true"
import script from "./TablesList.vue?vue&type=script&lang=js"
export * from "./TablesList.vue?vue&type=script&lang=js"

import "./TablesList.vue?vue&type=style&index=0&id=ccc5be66&scoped=true&lang=scss"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ccc5be66"]])

export default __exports__